import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Tooltip from 'components/tooltip';
import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';

import type { Task } from '../../types';
import { activityTypes } from 'bundles/apex/activities/type/config';


interface Props {
  task: Task;
}

export default function TaskType({ task }: Props) {
  const config = task.taskType && activityTypes[task.taskType as keyof typeof activityTypes];
  if (!config) {
    return null;
  }

  return (
    <Tooltip content={config.label}>
      <Badge appearance="muted" variant="secondary" >
        <FontAwesomeIcon icon={config.icon} size="sm" />
      </Badge>
    </Tooltip>
  );
}
